export default function TermsAndConditions() {
  return (
    <main
      className="w-full h-full bg-cover bg-center px-10 pb-10 pt-5 overflow-y-auto bg-white dark:bg-[#0b0c15]"
    >
      <div className="prose mx-auto max-w-4xl dark:prose-invert">
        <h1 className="text-center pb-3 dark:text-white">Privacy Policy</h1>
        <p className="mb-4">
          At JNTO, your privacy is our top priority. This Privacy Policy outlines how we collect, use, and protect your information when you use our mobile application and related services (collectively referred to as the “Service”).
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">1. Information We Collect</h2>
        <h3 className="font-semibold mb-1">a. Personal Information</h3>
        <ul className="list-disc ml-6 mb-4">
          <li>Name</li>
          <li>Phone number</li>
          <li>Email address</li>
          <li>Contact list (only with your explicit permission)</li>
        </ul>

        <h3 className="font-semibold mb-1">b. Usage Data</h3>
        <ul className="list-disc ml-6 mb-4">
          <li>Messages (end-to-end encrypted; we cannot read them)</li>
          <li>Device information (model, OS, unique identifiers)</li>
          <li>IP address and approximate location (used for server connection optimization)</li>
          <li>Crash logs and diagnostics (to improve app performance)</li>
        </ul>

        <h2 className="text-xl font-semibold mt-6 mb-2">2. How We Use Your Information</h2>
        <ul className="list-disc ml-6 mb-4">
          <li>Provide secure messaging and communication</li>
          <li>Facilitate account creation and authentication</li>
          <li>Improve app performance and user experience</li>
          <li>Prevent fraud and enhance security</li>
          <li>Provide customer support</li>
        </ul>
        <p className="mb-4"><strong>Note:</strong> We do not sell your personal data to third parties.</p>

        <h2 className="text-xl font-semibold mt-6 mb-2">3. End-to-End Encryption</h2>
        <p className="mb-4">
          Your messages, voice notes, and files are encrypted end-to-end. This means only you and the intended recipients can read or access them—not even JNTO can decrypt your communication.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">4. Sharing of Information</h2>
        <p className="mb-2">We do not share your personal information except in the following cases:</p>
        <ul className="list-disc ml-6 mb-4">
          <li>With your consent</li>
          <li>To comply with legal obligations</li>
          <li>To prevent fraud, abuse, or threats to security</li>
        </ul>

        <h2 className="text-xl font-semibold mt-6 mb-2">5. Data Storage and Security</h2>
        <p className="mb-4">
          We use secure servers and best-in-class encryption protocols to store your data. Sensitive information is encrypted both in transit and at rest. We implement strict access controls and periodically review our security practices to prevent unauthorized access.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">6. Data Retention</h2>
        <p className="mb-4">
          We retain your account and chat metadata only as long as necessary to provide the service or as required by law. You may delete your account at any time, which will remove your personal data from our servers.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">7. Your Rights</h2>
        <p className="mb-2">Depending on your location, you may have the right to:</p>
        <ul className="list-disc ml-6 mb-4">
          <li>Access the personal data we hold about you</li>
          <li>Request correction or deletion of your data</li>
          <li>Withdraw consent for data processing</li>
          <li>Request data portability</li>
        </ul>

        <h2 className="text-xl font-semibold mt-6 mb-2">8. Children’s Privacy</h2>
        <p className="mb-4">
          JNTO is not intended for use by children under the age of 13. We do not knowingly collect data from children. If we discover such data, it will be deleted immediately.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">9. Third-Party Services</h2>
        <p className="mb-4">
          We may use third-party tools for analytics or error monitoring. These services may collect data as described in their own privacy policies. We encourage you to review them.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">10. Changes to This Policy</h2>
        <p className="mb-4">
          We may update this Privacy Policy from time to time. Any changes will be posted within the app and/or our website. Continued use of the Service indicates your acceptance of the updated policy.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">11. Contact Us</h2>
        <p className="mb-4">
          If you have any questions or concerns about this Privacy Policy, please contact us at: <br />
          <strong>Email:</strong> <a href="mailto:tj@textdrip.com" className="text-blue-600 underline">tj@textdrip.com</a>
        </p>

      </div>
    </main>
  );
}
